import { useEffect, useLayoutEffect, useMemo } from "react";

import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useGetConfigQuery } from "../../store/settings/settingsService";
import { usePublicConfig } from "../../hooks/usePublicConfig";
import {
  setCartId,
  setModuleCode,
  setStoreAdminUrl,
  setStoreUrl,
  setWixGetParam,
} from "../../store/settings/settingsSlice";
import { WIX_ENV } from "../../utils";

const SettingsProvider = ({ children }) => {
  const location = useLocation();
  const { env } = usePublicConfig();
  const dispatch = useDispatch();
  const { isLoading } = useGetConfigQuery({});

  const searchParamsObject = useMemo(
    () => Object.fromEntries(new URLSearchParams(location.search)),
    [location.search],
  );

  useEffect(() => {
    if (!WIX_ENV?.includes(env?.hostEnv)) return;

    if (Object.keys(searchParamsObject || {}).length > 0) {
      dispatch(setWixGetParam(searchParamsObject));
    }
  }, [searchParamsObject]);

  useLayoutEffect(() => {
    dispatch(setStoreUrl(searchParamsObject?.storeUrl || ""));
  }, [searchParamsObject?.storeUrl]);

  useLayoutEffect(() => {
    dispatch(setStoreAdminUrl(searchParamsObject?.storeAdminUrl || ""));
  }, [searchParamsObject?.storeAdminUrl]);

  useLayoutEffect(() => {
    dispatch(setModuleCode(searchParamsObject?.module_code || ""));
  }, [searchParamsObject?.module_code]);

  useLayoutEffect(() => {
    dispatch(setCartId(searchParamsObject?.cart_id || ""));
  }, [searchParamsObject?.cart_id]);

  return children;
};

export default SettingsProvider;
